import type { PullRequestRightPanelSurface } from "~/rightPanelSurface";
import { pullRequestReferenceFromSurface } from "./chatPullRequestPane.logic";
import { PullRequestDetailPanel } from "./PullRequestDetailPanel";

export function ChatPullRequestPane({
  surface,
}: {
  readonly surface: PullRequestRightPanelSurface;
}) {
  return (
    <PullRequestDetailPanel
      environmentId={surface.environmentId}
      reference={pullRequestReferenceFromSurface(surface)}
      context="thread"
    />
  );
}
